import { useEffect } from 'react'
import { FieldValues, UseFormSetValue } from 'libs/form'
import { Country } from 'shared/types/general.types'

type UseSetCountryProps = {
	countries: Country[] | undefined
	country: Country['value'] | undefined
	setValue: UseFormSetValue<FieldValues>
}

export const useSetCountry = ({ countries, country, setValue }: UseSetCountryProps) => {
	useEffect(() => {
		if (countries?.length && country) {
			setValue('country', {
				value: country,
				label: countries?.find((c) => c.value === country)?.display_name
			})
		}
	}, [countries, country])
}
